module.exports = __webpack_public_path__ + "static/media/imad.93551a42.jpg";